<mulo-header-nav role="navigation" attr.aria-label="{{ariaLabel()}}">
  <ng-content></ng-content>
  @if (showMoreButton) {
    <mulo-header-nav-item class="menu-button">
      <ng-content select="[matMenuTriggerFor]"></ng-content>
    </mulo-header-nav-item>
  }
</mulo-header-nav>
